import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** 讀取這筆物料目前的物料序號關聯。版本用 data.record.updatedAt。 */
export async function fetchMtrSnMappings(id) {
  const { data: raw } = await request.get(`/mtr/${id}/sn-mappings`);
  return parseVer4DetailResponse(raw);
}
